import { Component } from '@angular/core';

@Component({
  selector: 'app-lock-icon',
  imports: [],
  templateUrl: './lock-icon.component.html',
})
export class LockIconComponent {

}
